import { render, staticRenderFns } from "./GroupRoleUserList.vue?vue&type=template&id=1d056889&"
import script from "./GroupRoleUserList.vue?vue&type=script&lang=js&"
export * from "./GroupRoleUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports